import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "moment/locale/az";
import "./style.css";
import moment from "moment-timezone";

const UpdatesModalTuitionFeeDetails = () => {
  const { updatesModalData: modalData, isLoading: updatesModalLoading } =
    useSelector((state) => state.updatesModal);

  const oldPaids =
    modalData?.oldData?.paids?.map((item) => ({
      paymentDate: item.paymentDate,
      payment: item.payment,
      confirmed: item.confirmed,
    })) || [];
  const newPaids =
    modalData?.newData?.paids?.map((item) => ({
      paymentDate: item.paymentDate,
      payment: item.payment,
      confirmed: item.confirmed,
    })) || [];

  const oldPaidsJson = JSON.stringify(oldPaids);
  const newPaidsJson = JSON.stringify(newPaids);

  // console.log(oldPaidsJson, 'old paids json')
  // console.log(newPaidsJson, 'new paids json')

  return (
    <div className="updates-datas-container">
      <div className="updates-list">
        <div className="update-row">
          <span className="updates-key">Ad, Soyad:</span>
          <span className="update-value old">
            {modalData?.oldData?.student?.fullName}
          </span>
        </div>
        <div className="update-row">
          <span className="updates-key">Fin:</span>
          <span className="update-value old">
            {modalData?.oldData?.student?.fin}
          </span>
        </div>
        <div className="update-row">
          <span className="updates-key">Mobil nömrə:</span>
          <span className="update-value old">
            {modalData?.oldData?.student?.phone}
          </span>
        </div>{" "}
        <div className="update-row">
          <span className="updates-key">Qrup adı:</span>
          <span className="update-value old">
            {modalData?.oldData?.group?.name}
          </span>
        </div>
        <div className={`update-row groups`}>
          <div className="group-container">
            <span className="updates-key old">Ödənişlər:</span>

            <div className="update-value old group-render">
              <div
                style={{
                  margin: "0px 0px 40px 40px",
                  padding: "10px",
                  boxSizing: "border-box",
                  borderRadius: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    marginLeft: "20px",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <p style={{ padding: "10px", border: "1px solid gray" }}>
                    {(!modalData?.oldData?.paids ||
                      modalData.oldData.paids.length === 0) && (
                      <p>ödəniş yoxdur</p>
                    )}

                    {modalData?.oldData?.paids?.map((paid, i) => {
                      return (
                        <div key={i} style={{ borderBottom: "1px solid gray" }}>
                          <p>
                            Ödəmə tarixi:{" "}
                            {moment(paid?.paymentDate)
                              .tz("Asia/Baku")
                              .format("DD:MM:YYYY")}{" "}
                          </p>
                          <p>Ödəniş: {paid?.payment}AZN </p>
                          <p>
                            Status:{" "}
                            {paid?.confirmed ? "Təsdiqləndi" : "gözləmədə"}
                          </p>
                        </div>
                      );
                    })}
                  </p>
                  <span
                    style={{
                      color:
                        oldPaidsJson === newPaidsJson ? "#2ecc71" : "#e74c3c",
                    }}
                  >
                    &#8594;
                  </span>
                  <p
                    style={{
                      marginLeft: "30px",
                      padding: "10px",
                      backgroundColor:
                        oldPaidsJson === newPaidsJson ? "#d4ffbf" : "#ffced1",
                    }}
                  >
                    {(!modalData?.newData?.paids ||
                      modalData?.newData?.paids.length === 0) && (
                      <p>ödəniş yoxdur</p>
                    )}

                    {modalData.newData?.paids?.map((paid, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            borderBottom: "1px solid gray",
                          }}
                        >
                          <p>
                            Ödəmə tarixi:{" "}
                            {moment(paid?.paymentDate)
                              .tz("Asia/Baku")
                              .format("DD:MM:YYYY")}{" "}
                          </p>
                          <p>Ödəniş: {paid?.payment}AZN </p>
                          <p>
                            Status:{" "}
                            {paid?.confirmed ? "Təsdiqləndi" : "gözləmədə"}
                          </p>
                        </div>
                      );
                    })}
                  </p>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatesModalTuitionFeeDetails;
